module.exports = __webpack_public_path__ + "img/sdk-arrow-right.a1f6eb99.svg";